import React from "react";
import Services from "../IndustrialCoverage/Industrial";

const IndustrialCoverage = () => {
  return (
    <section
      className="bg-gradient-to-b from-[#F2F2F2] to-[#ECECEC]"
      aria-label="Industrial coverage"
    >
      <Services />
    </section>
  );
};

export default IndustrialCoverage;
